import styled from 'styled-components'

export default styled.div`
	min-width: 16px;
	font-size: 14px;
	margin-right: 8px;
	display: flex;
	justify-content: center;
	pointer-events: none;
`